<template>
  <section id="contact" class="app-bar-offset">
    <!-- Contact Header Section -->
    <v-container class="my-2">
      <v-row>
        <v-col cols="12">
          <div class="mb-4 text-center">
            <span
              :class="[
                $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
              ]"
              class="font-weight-black black--text custom-font"
            >
              GET
            </span>
            <span
              :class="[
                $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
              ]"
              class="font-weight-black red--text custom-font"
            >
              IN TOUCH
            </span>
          </div>
          <div class="text-center">
            <span
              :class="[
                $vuetify.breakpoint.smAndDown ? 'headline-1' : 'headline-1',
              ]"
              class="font-weight-black black--text custom-font"
            >
              We're here to help and answer any question you might have. We look
              forward to hearing from you.
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Contact Details Section -->
    <v-container>
      <v-row>
        <!-- Contact Information Column -->
        <v-col cols="12" md="6">
          <v-card elevation="2" class="pa-5" color="#333333">
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="title">Location</v-list-item-title>
                  <v-list-item-subtitle
                    >164 Torbay Rd, Markham, ON L3R 1G6,
                    Canada</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="title">Phone</v-list-item-title>
                  <v-list-item-subtitle
                    >Main: (905)-479-3131</v-list-item-subtitle
                  >
                  <v-list-item-subtitle
                    >24/7 Emergency: (416)-821-5568</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="title">Email</v-list-item-title>
                  <v-list-item-subtitle
                    >admin@emswerek.com</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <!-- Ensure you are using the correct icon name from the Material Design Icons -->
                  <v-icon color="primary">mdi-information-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="title">Note</v-list-item-title>
                  <div class="body-1">
                    Please call us at our main line for any cleaning,
                    construction, or general service inquiries! For any
                    emergency services or requests made after 5 PM, reach us via
                    email or the 24/7 emergency line above.
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- Contact Form Column -->
        <v-col cols="12" md="6">
          <v-card elevation="2" class="pa-5" color="#333333">
            <!-- Introduction Text Section -->
            <div class="text-center mb-5">
              <p class="body-1 green--text text--lighten-4">
                You can reach us by phone, email, or message us here.
              </p>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name"
                required
                solo
              ></v-text-field>

              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                required
                solo
              ></v-text-field>
              <v-text-field
                v-model="phone"
                label="Telephone"
                required
                solo
              ></v-text-field>
              <v-textarea
                v-model="message"
                :rules="messageRules"
                label="How can we help you?"
                required
                solo
              ></v-textarea>
              <v-btn
                color="primary"
                @click="validate"
                :disabled="isSending"
                block
              >
                <!-- Change button text based on isSending state -->
                <span v-if="isSending" class="white--text">Sending...</span>
                <span v-else>Send Message</span>
              </v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="my-6"></v-divider>

    <!-- Google Maps Embed Section -->
    <v-container fluid class="pa-0">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d278715.6336141145!2d-79.60395943745876!3d43.820139022342396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d37ac2b0f943%3A0x7b76935c24f09259!2s164%20Torbay%20Rd%2C%20Markham%2C%20ON%20L3R%201G6%2C%20Canada!5e0!3m2!1sen!2suk!4v1704648270597!5m2!1sen!2suk"
        width="100%"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </v-container>
  </section>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  data() {
    return {
      valid: false,
      name: "",
      email: "",
      phone: "",
      message: "",
      nameRules: [(v) => !!v || "Name is required"],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      messageRules: [(v) => !!v || "Message is required"],
      template_params: {
        reply_to: "",
        from_name: "",
        to_name: "",
        message: "",
      },
      isSending: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.setTemplateParams();
        this.sendEmail();
      }
    },
    setTemplateParams() {
      // Concatenating the phone number with the message
      let fullMessage = `Phone: ${this.phone}\n\nMessage: ${this.message}`;
      this.template_params.message = fullMessage;
      this.template_params.reply_to = this.email;
      this.template_params.from_name = this.name;
      // You might want to add 'to_name' if necessary
    },
    sendEmail() {
      this.isSending = true; // Start sending process
      emailjs
        .send(
          "service_lkxj7id",
          "template_3lv7q7o",
          this.template_params,
          "qUB6aFT1sRfJKU5vi"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
            alert("Thanks, We will respond shortly");
            this.clearForm();
          },
          (error) => {
            console.log("FAILED...", error);
            alert("Message failed - please try again");
          }
        )
        .finally(() => {
          this.isSending = false; // Reset state regardless of success or failure
        });
    },
    clearForm() {
      this.name = "";
      this.email = "";
      this.message = "";
      this.phone = "";
    },
  },
};
</script>


<style scoped>
.app-bar-offset {
  margin-top: 100px; /* Adjust as per your app bar height */
  margin-bottom: 50px;
}
</style>


